import { CategoryHeaderBase as Header } from '../CategoryHeaderBase';
import { CategoryProductCount as ProductCount } from '../CategoryHeaderProductCount';
import { CategoryNameComp as CategoryName } from '../CategoryName';
import { BreadcrumbComp as Breadcrumb } from '../Breadcrumb';
import FilterAndSorting from '@/components/FilterAndSorting';

const CategoryHeader2 = () => {
  return (
    <Header classes="category-header-2 flex items-center justify-center flex-column">
      <div className={`flex items-center justify-center block-style`}>
        <Breadcrumb classes="category-breadcrumb-2" />
        <CategoryName classes="category-name-2" />
      </div>
      <div className="flex items-center justify-between w-100 relative">
        <ProductCount classes="tc center product-count-2" />
        {/* sort here */}
        <FilterAndSorting />
      </div>
    </Header>
  );
};

export default CategoryHeader2;
